import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import GtmService from 'static/script/app/ui/google-tagmanager-service';
import Flag from 'tradera-components/flag/flag';
import { selectPreferredLanguage } from 'tradera-state/language/selectors';
import { getCountryCodeFromLanguage } from 'tradera-utils/languagecode';
import './translation-strategy.scss';
import { useTranslator } from 'tradera-lang/translate';

export const TranslationStrategy = ({
    discoverTranslationResult,
    language,
    handleTranslationStrategyClick
}) => {
    const { t } = useTranslator();
    const {
        isInternationalSearchLightEnabled,
        query,
        translatedQuery
    } = discoverTranslationResult;
    const isDisabled =
        !isInternationalSearchLightEnabled ||
        !query ||
        !translatedQuery ||
        query.toLocaleLowerCase() === translatedQuery.toLocaleLowerCase();

    useEffect(() => {
        if (!isDisabled) {
            GtmService.trackAction('Search', 'Search Light Load', query);
        }
    }, [isDisabled, query]);

    if (isDisabled) {
        return null;
    }

    const onClick = q => {
        GtmService.trackAction(
            'Search',
            'Search Light Click',
            language.languageCodeIso2
        );
        handleTranslationStrategyClick(q);
    };

    const flagAndText = (countryCodeIso2, text) => (
        <>
            <Flag countryCodeIso2={countryCodeIso2} className="mx-1" />
            {text}
        </>
    );

    const swedish = flagAndText('se', translatedQuery);
    const foreign = flagAndText(
        getCountryCodeFromLanguage(language.languageCodeIso2),
        query
    );

    return (
        <>
            <div className="alert alert-info translation-strategy">
                <button
                    className="btn btn-link p-0 translation-strategy--button"
                    onClick={() => {
                        onClick(translatedQuery);
                    }}>
                    {t('discover_searchLight_translateOnclick_new_a')} {foreign}{' '}
                    {t('discover_searchLight_translateOnclick_new_b')} {swedish}
                    {t('discover_searchLight_translateOnclick_new_c')}
                </button>
            </div>
            <em className="alert m-0">
                {t('discover_searchLight_autoTranslated')}
            </em>
        </>
    );
};

export default connect(state => ({
    discoverTranslationResult: state.discover.discoverTranslationResult,
    language: selectPreferredLanguage(state)
}))(TranslationStrategy);
